import { render, staticRenderFns } from "./register-plus.vue?vue&type=template&id=e59f1d40&scoped=true&"
import script from "./register-plus.vue?vue&type=script&lang=js&"
export * from "./register-plus.vue?vue&type=script&lang=js&"
import style0 from "@/assets/sass/bootstrap4.css?vue&type=style&index=0&id=e59f1d40&scoped=true&lang=css&"
import style1 from "@/assets/sass/home.css?vue&type=style&index=1&id=e59f1d40&scoped=true&lang=css&"
import style2 from "./register.scss?vue&type=style&index=2&id=e59f1d40&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e59f1d40",
  null
  
)

export default component.exports